import React, { useState, useEffect } from 'react';
import { STRIPE_DONATE } from '../constants';
import Icon from './ui/Icons';

const RED = '#c94545';
const GOLD = '#c8973a';
const TEXT = '#f0e8da';
const DIM = 'rgba(240,232,218,0.5)';
const DIMMER = 'rgba(240,232,218,0.3)';
const BG = '#1a1610';
const BORDER = 'rgba(201,69,69,0.2)';

const DonateButton = ({ compact = false }) => {
  const [showModal, setShowModal] = useState(false);

  if (compact) return (
    <>
      <button onClick={() => setShowModal(true)}
        style={{ padding: '5px 12px', borderRadius: '7px', fontSize: '12px', fontWeight: '600', backgroundColor: 'rgba(201,69,69,0.1)', color: RED, border: `1px solid ${BORDER}`, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}>
        <Icon name="heart" size={11} color={RED} /> Support
      </button>
      {showModal && <DonateModal onClose={() => setShowModal(false)} />}
    </>
  );

  return (
    <>
      <div style={{ padding: '20px', backgroundColor: 'rgba(201,69,69,0.06)', border: `1px solid ${BORDER}`, borderRadius: '16px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}><Icon name="heart" size={24} color={RED} /></div>
        <h3 style={{ fontSize: '14px', fontWeight: '700', color: TEXT, marginBottom: '4px' }}>Support Learnable</h3>
        <p style={{ fontSize: '12px', color: DIM, marginBottom: '14px', lineHeight: 1.5 }}>Built by a student, free forever. API costs come out of pocket. Every donation keeps this running.</p>
        <button onClick={() => setShowModal(true)}
          style={{ padding: '8px 20px', borderRadius: '10px', fontSize: '13px', fontWeight: '700', backgroundColor: RED, color: '#fff', border: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          <Icon name="heart" size={13} color="#fff" /> Donate
        </button>
      </div>
      {showModal && <DonateModal onClose={() => setShowModal(false)} />}
    </>
  );
};

const DonateModal = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const h = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', h);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', h);
    };
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 }}>
      <div
        onClick={e => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 420, backgroundColor: BG, border: `1px solid ${BORDER}`, borderRadius: 20, padding: 32, textAlign: 'center', boxShadow: '0 24px 64px rgba(0,0,0,0.6)', boxSizing: 'border-box', animation: 'fadeInScale 0.2s ease forwards', fontFamily: "'DM Sans',sans-serif", maxHeight: '90vh', overflowY: 'auto' }}>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
          <Icon name="heart" size={40} color={RED} />
        </div>

        <h2 style={{ fontSize: 20, fontWeight: 800, color: TEXT, marginBottom: 8, fontFamily: "'DM Serif Display',serif" }}>Support Learnable</h2>
        <p style={{ fontSize: 13, color: DIM, lineHeight: 1.65, marginBottom: 24 }}>
          Learnable is completely free and built by a student. The Claude AI API costs real money every time you use it. Your donation directly keeps this platform running for you and thousands of other students.
        </p>

        <a
          href={STRIPE_DONATE}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '14px', borderRadius: 12, fontSize: 15, fontWeight: 800, backgroundColor: RED, color: '#fff', textDecoration: 'none', marginBottom: 16 }}>
          <Icon name="heart" size={16} color="#fff" /> Donate to Learnable
        </a>

        <div style={{ padding: '12px 14px', backgroundColor: `rgba(200,151,58,0.08)`, border: `1px solid rgba(200,151,58,0.15)`, borderRadius: 10, marginBottom: 16 }}>
          <p style={{ fontSize: 12, color: DIM, lineHeight: 1.55, margin: 0 }}>
            You can also support by sharing Learnable with friends — every new student helps justify the costs.
          </p>
        </div>

        <button onClick={onClose} style={{ fontSize: 13, color: DIMMER, background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
          Maybe later
        </button>
      </div>
    </div>
  );
};

export default DonateButton;
